// @flow

export const PAYMENT_SCHEDULE_PREPAID = 'Prepaid';
export const PAYMENT_SCHEDULE_ARREARS = 'Arrears';
export const PAYMENT_SCHEDULE_ARREARS_DISPLAY_NAME = 'Payable in Arrears';
export const MARKETPLACE_NONE = 'None';
export const DEAL_TYPE_RENEWAL = 'Renewal';
export const RATE_CARD_VERSION_4_11_2024 = '4/11/2024';
